///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API } from "../api/axios";

export const postAttachment = (
  bidId,
  overwriteAttachments,
  attachments,
  config,
  isAwardUpload = false
) => {
  var formData = new FormData();

  formData.append("overwriteAttachments", overwriteAttachments);
  formData.append("bidId", bidId);
  if (isAwardUpload === true) {
    formData.append("isAwardUpload", true);
  }
  attachments.forEach(file => formData.append("attachments", file));

  return API.post("api/v1.0/attachments", formData, config);
};

export const downloadAttachment = (name, bidId) =>
  API.get("api/v1.0/attachments", {
    params: { name, bidId },
    responseType: "blob"
  });

export const getBidAttachments = bidId => {
  return API.get("api/v1.0/attachments/metadata", {
    params: {
      bidId: bidId
    }
  });
};

export const deleteAttachment = request => {
  return API.delete("api/v1.0/attachments", {
    data: request
  });
};

export const getSupportedFiles = () => {
  return API.get("api/v1.0/attachments/supported-file-types");
};

export const postAttachmentV2 = (
  bidId,
  overwriteAttachments,
  attachments,
  config,
  isAwardUpload = false
) => {
  var formData = new FormData();

  formData.append("overwriteAttachments", overwriteAttachments);
  formData.append("bidId", bidId);
  attachments.forEach(file => formData.append("attachments", file));

  const url =
    isAwardUpload === true
      ? "api/v1.0/attachments/v2?isAwardUpload=true"
      : "api/v1.0/attachments/v2";

  return API.post(url, formData, config);
};
